<template>
    <div class="r-item">
        <div class='r-a' :title="a_info">
        <div class="name"> {{item.a_object.name}}<span class="help-class color-blue" v-if="index===0" title="点击出现提示" @click="$emit('help-msg',3)">?</span></div>
           <input :class="[a_move_left?'text_set_right':'text_move_left']"  type="text" :value="item.a_object.value" onfocus="this.select()"  style="background-color:inherit">
        </div>
        <div class='r-b' :title="b_info">
            
            <div class="name"> {{item.b_object.name}}</div>
            <!-- <div class="name"> {{item.b_object.value}}</div> -->
           <div style="text-align:center;">
               <input :class="[b_move_left?'text_set_right':'text_move_left']" type="text" :value="item.b_object.value" onfocus="this.select()" readonly='true' style="background-color:inherit"> 
                <span class="help-class color-red" v-if="index===0" title="点击出现提示" @click="$emit('help-msg',2)">?</span>
           </div>
           <div class="item_btn" @click="$emit('calc_pa',index)" @dbclick="$emit('calc_pa','all')" title="后验概率计算"></div>
            
        </div>
    </div>
    
</template>

<script>
export default {
   name:'BayRItem',
    data(){
        return {
            a_move_left:false,
            b_move_left:false,
        }
    },
    props:{
       item:Object,
       name:String,
       is_bi:Boolean,
       index:Number,
       event_info:Object,

   },
   methods: {
       text_move(ele){
           console.log(ele);
       }
   },
    computed:{
        b_value(){
            return this.item.b_object.value
        },
        a_value(){
            return this.item.a_object.value
        },

        bi_event(){//标记事件是否为正反事件，title不一样
           return this.is_bi
       },
       a_info(){
           if(this.bi_event){
               return `${this.event_info.event_B} 中 ${this.name} 的比率 `
           }else{
               return `${this.event_info.event_B} 中 来自${this.event_info.event_A} ${this.name}  的比值 `
           }
       },
       b_info(){
            if(this.bi_event){
               return `${this.event_info.event_B} 来自 ${this.name}  占所有${this.event_info.event_A}的比值 `
           }else{
               return `${this.event_info.event_B} 来自 ${this.name}  占所有${this.event_info.event_A}的比值 `
           }
           
       },
   },
   watch:{
       b_value(){
           //this.item.b_object.value = ' ' + this.item.b_object.value;
           console.log('b_value ' + this.index + ' value changed');
           this.b_move_left = true;
           setTimeout(()=>this.b_move_left=false,100);
       },
       a_value(){
           console.log('a_value ' + this.index + ' value changed');
           this.a_move_left = true;
           setTimeout(()=>this.a_move_left=false,100);
       }
   }
}
</script>

<style lang="stylus" scoped>
@import '~css/item.styl';
@import '~css/var.styl';
@import '~css/mixins.styl';
$input_width=60%;
.r-item
   item()
   background-color:$bay_item_r_color

.r-a 
    child_item(1)
    background-color:$bay_item_r_a_color
    & input
        box-sizing:border-box;
        text-align:center;

.r-b
    child_item(2)
    background-color:$bay_item_r_b_color
    position relative
    & input
        box-sizing:border-box;
        text-align:center;
.text_move_left
    padding-left:0%;
    transition:padding 1s;

.text_set_right
    padding-left:50%;
    

.item_btn
    position:absolute;
    top:0%;
    background-color:lightblue;
    transform:translateY(-23px);
    z-index:2;
    width:50px;
    height:60px;
    background:url('~pic/up_blue2.png') center no-repeat;
    background-size:100% 100%;
    &:hover
        box-shadow:1px 1px 3px gray

.name{
    white-space:nowrap;
    overflow: hidden;
    /* text-overflow: ellipsis; */
    width: 100%;
    text-align: center;
    min-width: 163px;
}
.color-blue
    background-color:blue;


.color-red
    background-color:red;


.help-class
    margin-left:5px;
    border:1px solid white;
    // background-color:purple;
    color:white;
    width:15px;
    height:15px;
    display:inline-block;
    text-align: center;
    font-size:12px;
    border-radius:50%;
    cursor:pointer;
    &:hover
        background-color:white;
        color:purple;
   

</style>
